var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsSemiFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50003 2H2.91667C2.41041 2 2 2.41041 2 2.91667V7.50003C2 8.00629 2.41041 8.4167 2.91667 8.4167H7.50003C8.00629 8.4167 8.4167 8.00629 8.4167 7.50003V2.91667C8.4167 2.41041 8.00629 2 7.50003 2Z",
    fill: "#DAE4EE",
    stroke: "#DAE4EE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.584 2H13.0007C12.4944 2 12.084 2.41041 12.084 2.91667V7.50003C12.084 8.00629 12.4944 8.4167 13.0007 8.4167H17.584C18.0903 8.4167 18.5007 8.00629 18.5007 7.50003V2.91667C18.5007 2.41041 18.0903 2 17.584 2Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.584 12.084H13.0007C12.4944 12.084 12.084 12.4944 12.084 13.0007V17.584C12.084 18.0903 12.4944 18.5007 13.0007 18.5007H17.584C18.0903 18.5007 18.5007 18.0903 18.5007 17.584V13.0007C18.5007 12.4944 18.0903 12.084 17.584 12.084Z",
    fill: "#DAE4EE",
    stroke: "#DAE4EE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50003 12.084H2.91667C2.41041 12.084 2 12.4944 2 13.0007V17.584C2 18.0903 2.41041 18.5007 2.91667 18.5007H7.50003C8.00629 18.5007 8.4167 18.0903 8.4167 17.584V13.0007C8.4167 12.4944 8.00629 12.084 7.50003 12.084Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsSemiFill);
export default __webpack_public_path__ + "static/media/applicationsSemiFill.10a3395ee9ea2ee5c1a3b6ffc5b17e55.svg";
export { ForwardRef as ReactComponent };